module.exports = __webpack_public_path__ + "static/media/291975.192c90d0.png";